<div class="max-w-full mx-auto p-8 bg-white rounded-2xl shadow-lg border border-gray-200 ml-16">

  <div class="flex justify-between items-center mb-8">
    <div>
      <h2 class="text-2xl font-bold text-gray-800 mb-1">Rezultati tarč</h2>
      <p class="text-gray-600">Pregled rezultatov in tarč za izbran mesec</p>
    </div>
    <div class="flex items-center gap-3">
      <div class="relative flex items-center gap-2 rounded-xl border border-gray-200 bg-gray-50 px-2 py-2 shadow-sm">
        <button
          type="button"
          class="flex h-10 w-10 items-center justify-center rounded-lg text-gray-600 transition-colors hover:bg-white hover:text-blue-600"
          (click)="previousMonth()">
          <i class="fas fa-chevron-left"></i>
        </button>
        <button
          type="button"
          class="w-36 rounded-lg bg-white px-4 py-2 text-sm font-semibold text-gray-800 shadow-sm transition-colors hover:bg-blue-50 hover:text-blue-700"
          (click)="toggleMonthPicker()">
          {{ selectedMonthLabel }}
        </button>
        <button
          type="button"
          class="flex h-10 w-10 items-center justify-center rounded-lg text-gray-600 transition-colors hover:bg-white hover:text-blue-600"
          (click)="nextMonth()">
          <i class="fas fa-chevron-right"></i>
        </button>

        <div *ngIf="monthPickerOpen" class="absolute right-0 top-full z-20 mt-2 w-72 rounded-2xl border border-gray-200 bg-white p-4 shadow-2xl">
          <div class="mb-3 flex items-center justify-between">
            <span class="text-sm font-semibold text-gray-700">Izberi mesec</span>
            <span class="text-sm text-gray-500">{{ selectedMonth.getFullYear() }}</span>
          </div>
          <div class="grid grid-cols-3 gap-2">
            <button
              *ngFor="let monthLabel of monthLabels; let monthIndex = index"
              type="button"
              class="rounded-lg px-3 py-2 text-sm font-medium transition-colors"
              [ngClass]="isSelectedMonth(monthIndex) ? 'bg-blue-600 text-white shadow-md' : 'bg-gray-50 text-gray-700 hover:bg-blue-50 hover:text-blue-700'"
              (click)="selectMonth(monthIndex)">
              {{ monthLabel }}
            </button>
          </div>
        </div>
      </div>

      <button
        class="px-7 py-2.5 text-base font-semibold rounded-lg cursor-pointer transition-all duration-200 border-none outline-none shadow-md bg-green-50 text-green-700 border border-green-200 hover:bg-green-100 hover:text-green-800"
        (click)="openTarcaAddDialog()">
        <i class="fas fa-plus mr-2"></i>Dodaj tarčo
      </button>
      <label class="flex items-center gap-3 rounded-lg border border-blue-200 bg-blue-50 px-4 py-2.5 text-sm font-semibold text-blue-700">
        <span>Preizkusne tarče</span>
        <span class="relative inline-flex h-6 w-11 shrink-0">
          <input
            type="checkbox"
            class="peer sr-only"
            [(ngModel)]="dockDown"
            name="showTestTargets"
            (ngModelChange)="toggleDock($event)"
            aria-label="Vključi ali izključi preizkusne tarče">
          <span class="absolute inset-0 cursor-pointer rounded-full bg-gray-300 transition-colors peer-checked:bg-blue-600"></span>
          <span class="pointer-events-none absolute left-1 top-1 h-4 w-4 rounded-full bg-white shadow transition-transform peer-checked:translate-x-5"></span>
        </span>
        <span class="min-w-16 text-right">{{ dockDown ? 'Vključene' : 'Izključene' }}</span>
      </label>
    </div>
  </div>

  <div class="mb-6 grid grid-cols-1 gap-3 rounded-xl border border-blue-100 bg-blue-50 p-4 md:grid-cols-5">
    <label class="relative flex flex-col gap-1 text-sm font-semibold text-gray-700">
      Strelec
      <input [(ngModel)]="memberFilterSearch" name="memberFilterSearch" (focus)="openFilter = 'member'" class="rounded-lg border border-blue-200 bg-white px-3 py-2" placeholder="Vsi strelci" autocomplete="off">
      <button *ngIf="selectedMember" type="button" class="absolute right-2 top-7 text-gray-400 hover:text-gray-700" (click)="clearFilter('member')" aria-label="Počisti strelca"><i class="fas fa-times"></i></button>
      <div *ngIf="openFilter === 'member' && filteredMemberOptions.length" class="absolute left-0 right-0 top-full z-30 mt-1 max-h-52 overflow-y-auto rounded-lg border border-blue-200 bg-white py-1 shadow-xl">
        <button *ngFor="let member of filteredMemberOptions" type="button" class="block w-full px-3 py-2 text-left text-sm font-normal hover:bg-blue-50" (mousedown)="$event.preventDefault()" (click)="selectFilter('member', member)">{{ member }}</button>
      </div>
    </label>
    <label class="relative flex flex-col gap-1 text-sm font-semibold text-gray-700">
      Klub
      <input [(ngModel)]="clubFilterSearch" name="clubFilterSearch" (focus)="openFilter = 'club'" class="rounded-lg border border-blue-200 bg-white px-3 py-2" placeholder="Vsi klubi" autocomplete="off">
      <button *ngIf="selectedClub" type="button" class="absolute right-2 top-7 text-gray-400 hover:text-gray-700" (click)="clearFilter('club')" aria-label="Počisti klub"><i class="fas fa-times"></i></button>
      <div *ngIf="openFilter === 'club' && filteredClubOptions.length" class="absolute left-0 right-0 top-full z-30 mt-1 max-h-52 overflow-y-auto rounded-lg border border-blue-200 bg-white py-1 shadow-xl">
        <button *ngFor="let club of filteredClubOptions" type="button" class="block w-full px-3 py-2 text-left text-sm font-normal hover:bg-blue-50" (mousedown)="$event.preventDefault()" (click)="selectFilter('club', club)">{{ club }}</button>
      </div>
    </label>
    <label class="relative flex flex-col gap-1 text-sm font-semibold text-gray-700">
      Tekmovanje
      <input [(ngModel)]="competitionFilterSearch" name="competitionFilterSearch" (focus)="openFilter = 'competition'" class="rounded-lg border border-blue-200 bg-white px-3 py-2" placeholder="Vsa tekmovanja" autocomplete="off">
      <button *ngIf="selectedCompetition" type="button" class="absolute right-2 top-7 text-gray-400 hover:text-gray-700" (click)="clearFilter('competition')" aria-label="Počisti tekmovanje"><i class="fas fa-times"></i></button>
      <div *ngIf="openFilter === 'competition' && filteredCompetitionOptions.length" class="absolute left-0 right-0 top-full z-30 mt-1 max-h-52 overflow-y-auto rounded-lg border border-blue-200 bg-white py-1 shadow-xl">
        <button *ngFor="let competition of filteredCompetitionOptions" type="button" class="block w-full px-3 py-2 text-left text-sm font-normal hover:bg-blue-50" (mousedown)="$event.preventDefault()" (click)="selectFilter('competition', competition)">{{ competition }}</button>
      </div>
    </label>
    <label class="relative flex flex-col gap-1 text-sm font-semibold text-gray-700">
      Kategorija
      <input [(ngModel)]="categoryFilterSearch" name="categoryFilterSearch" (focus)="openFilter = 'category'" class="rounded-lg border border-blue-200 bg-white px-3 py-2" placeholder="Vse kategorije" autocomplete="off">
      <button *ngIf="selectedCategory" type="button" class="absolute right-2 top-7 text-gray-400 hover:text-gray-700" (click)="clearFilter('category')" aria-label="Počisti kategorijo"><i class="fas fa-times"></i></button>
      <div *ngIf="openFilter === 'category' && filteredCategoryOptions.length" class="absolute left-0 right-0 top-full z-30 mt-1 max-h-52 overflow-y-auto rounded-lg border border-blue-200 bg-white py-1 shadow-xl">
        <button *ngFor="let category of filteredCategoryOptions; let index = index" type="button" class="block w-full px-3 py-2 text-left text-sm font-normal hover:bg-blue-50" (mousedown)="$event.preventDefault()" (click)="selectFilter('category', category)">{{ index + 1 }}. {{ category }}</button>
      </div>
    </label>
    <div class="flex items-end justify-between gap-3">
      <span class="pb-2 text-sm font-semibold text-blue-800">Prikazanih rezultatov: {{ resultsTargets.length }}</span>
      <button type="button" (click)="clearFilters()" class="rounded-lg border border-blue-200 bg-white px-3 py-2 text-sm font-semibold text-blue-700 hover:bg-blue-100">Počisti</button>
    </div>
  </div>

  <table *ngIf="resultsTargets.length > 0" class="w-full border-collapse bg-white shadow-lg my-6 text-sm rounded-xl overflow-hidden">
    <thead>
      <tr class="bg-gradient-to-r from-blue-100 to-blue-300">
        <th class="px-4 py-3 text-left text-blue-800 font-bold border-b-2 border-blue-200"><i class="fas fa-bullseye mr-2"></i>ID tarče</th>
        <th class="px-4 py-3 text-left text-blue-800 font-bold border-b-2 border-blue-200">Ime tarče</th>
        <th class="px-4 py-3 text-left text-blue-800 font-bold border-b-2 border-blue-200">Predlagana vrsta tarče</th>
        <th class="px-4 py-3 text-left text-blue-800 font-bold border-b-2 border-blue-200">Datum tarče</th>
        <th class="px-4 py-3 text-left text-blue-800 font-bold border-b-2 border-blue-200"><i class="fas fa-user mr-2"></i>Ime Strelca</th>
        <th class="px-4 py-3 text-left text-blue-800 font-bold border-b-2 border-blue-200"><i class="fas fa-home mr-2"></i>Klub</th>
        <th class="px-4 py-3 text-left text-blue-800 font-bold border-b-2 border-blue-200">Tekmovanje</th>
        <th class="px-4 py-3 text-left text-blue-800 font-bold border-b-2 border-blue-200">Kategorija</th>
        <th class="px-4 py-3 text-left text-blue-800 font-bold border-b-2 border-blue-200">S10</th>
        <th class="px-4 py-3 text-left text-blue-800 font-bold border-b-2 border-blue-200">S20</th>
        <th class="px-4 py-3 text-left text-blue-800 font-bold border-b-2 border-blue-200">S30</th>
        <th class="px-4 py-3 text-left text-blue-800 font-bold border-b-2 border-blue-200">S40</th>
        <th class="px-4 py-3 text-left text-blue-800 font-bold border-b-2 border-blue-200">S50</th>
        <th class="px-4 py-3 text-left text-blue-800 font-bold border-b-2 border-blue-200">S60</th>
        <th class="px-4 py-3 text-left text-blue-800 font-bold border-b-2 border-blue-200">Notranji center</th>
        <th class="px-4 py-3 text-left text-blue-800 font-bold border-b-2 border-blue-200">Skupaj</th>
        <th class="px-4 py-3 text-left text-blue-800 font-bold border-b-2 border-blue-200">Vrsta tarče</th>
        <th class="px-4 py-3 text-left text-blue-800 font-bold border-b-2 border-blue-200"><i class="fas fa-info-circle mr-2"></i>Dodatne informacije</th>
      </tr>
    </thead>
    <tbody>
  <tr *ngFor="let target of resultsTargets"
      class="border-b border-blue-100 even:bg-blue-50 hover:bg-blue-100 transition-colors duration-150">
        <td class="px-4 py-3 text-gray-700 font-semibold">
          {{ target.targetID }}
        </td>
        <td class="px-4 py-3 text-gray-700">{{ target.target_name || target.TargetOrder || '-' }}</td>
        <td class="px-4 py-3 text-gray-700">{{ getTargetTypeDisplay(target) }}</td>
        <td class="px-4 py-3 text-gray-700">{{ formatServerDate(target.target_date) }}</td>
        <td class="px-4 py-3 text-gray-700">{{ target.member_full_name }}</td>
        <td class="px-4 py-3 text-gray-700">{{ target.club_name || '-' }}</td>
        <td class="px-4 py-3 text-gray-700">{{ target.competition_name }}</td>
        <td class="px-4 py-3 text-gray-700">{{ target.category_name }}</td>
        <td class="px-4 py-3 text-gray-700">{{ formatSeriesScore(target.S10, target) }}</td>
        <td class="px-4 py-3 text-gray-700">{{ formatSeriesScore(target.S20, target) }}</td>
        <td class="px-4 py-3 text-gray-700">{{ formatSeriesScore(target.S30, target) }}</td>
        <td class="px-4 py-3 text-gray-700">{{ formatSeriesScore(target.S40, target) }}</td>
        <td class="px-4 py-3 text-gray-700">{{ formatSeriesScore(target.S50, target) }}</td>
        <td class="px-4 py-3 text-gray-700">{{ formatSeriesScore(target.S60, target) }}</td>
        <td class="px-4 py-3 text-gray-700">{{ target.inner_center }}</td>
  <td class="px-4 py-3 text-blue-900 font-bold">
    <strong>{{ isTeilerTarget(target) ? (target.teiler_score | number:'1.0-0') : formatTotalScore(target) }}</strong>
    <small *ngIf="isTeilerTarget(target)" class="block text-xs font-medium text-blue-700">Decimalno: {{ target.series_sum | number:'1.1-1' }}</small>
  </td>
        <td class="px-4 py-3">
          <select
            class="max-w-52 px-2 py-2 bg-white border border-blue-200 rounded-lg text-sm"
            name="xmlTarget-{{ target.targetID }}"
            [disabled]="!savedXmlTargets.length"
            [(ngModel)]="selectedXmlTargetIds[target.targetID]"
            (ngModelChange)="assignXmlTarget(target.targetID, $event)">
            <option [ngValue]="null">Brez izbrane vrste</option>
            <option *ngFor="let xmlTarget of savedXmlTargets" [ngValue]="xmlTarget.id">
              {{ xmlTarget.display_name }}
            </option>
          </select>
          <span *ngIf="selectedXmlTargetIds[target.targetID]" class="block mt-1 text-xs text-blue-700">
            Izbrano: {{ getTargetTypeDisplay(target) }}
          </span>
        </td>
        <td class="px-4 py-3">
          <div class="flex gap-2">
            <button [routerLink]="['/tarca', target.targetID]" 
                    class="px-4 py-2 bg-blue-500 text-white border-none rounded-lg cursor-pointer text-sm font-semibold transition-colors hover:bg-blue-600 shadow-md">
              <i class="fas fa-info-circle mr-1"></i>Info
            </button>
            <button class="px-4 py-2 bg-blue-500 text-white border-none rounded-lg cursor-pointer text-sm font-semibold transition-colors hover:bg-blue-600 shadow-md" 
              (click)="openRezultatiAddDialog(target)">
              <i class="fas fa-edit mr-1"></i>Uredi strelca
            </button>
            <button *ngIf="!isUnitTwo" class="px-4 py-2 bg-green-500 text-white border-none rounded-lg cursor-pointer text-sm font-semibold transition-colors hover:bg-green-600 shadow-md" 
              (click)="copyTarget(target)">
              <i class="fas fa-copy mr-1"></i>Kopiraj tarčo
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>

  <div *ngIf="hasMoreResults" class="my-6 flex justify-center">
    <button
      type="button"
      class="rounded-lg border border-blue-200 bg-blue-50 px-5 py-2.5 text-sm font-semibold text-blue-700 shadow-sm transition-colors hover:bg-blue-100"
      (click)="showNextResults()">
      Prikaži naslednjih 100
    </button>
  </div>
  
  <div *ngIf="resultsTargets.length === 0" class="my-12 bg-blue-50 p-8 rounded-xl border-2 border-dashed border-blue-200 text-center">
    <i class="fas fa-bullseye text-blue-300 text-4xl mb-4"></i>
  <h3 class="text-xl font-semibold text-blue-600 mb-2">Ni najdenih rezultatov</h3>
  <p class="text-blue-500 mb-4">Za izbrani mesec ali filtre ni najdenih tarč.</p>
  </div>

  <ng-container *ngIf="RezultatiAddDialogOpen">
    <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 backdrop-blur-sm">
      <app-rezultati-add-dialog
        [target]="selectedTarget"
        (save)="closeAddRezultatiDialog()"
        (cancel)="closeAddRezultatiDialog()">
      </app-rezultati-add-dialog>
    </div>
  </ng-container>

  <ng-container *ngIf="TarcaAddDialogOpen">
    <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 backdrop-blur-sm">
      <app-tarca-add-dialog
        (save)="closeTarcaAddDialog()"
        (cancel)="closeTarcaAddDialog()">
      </app-tarca-add-dialog>
    </div>
  </ng-container>
</div>

